import React, { useState } from 'react';
import Modal from '../../../main/components/Modal';
import './signup-modal.scss';
import PropTypes from 'prop-types';
import Register from '../../../admin/components/Register';
import CallUs from './CallUs';
import ArrangeCallBack from './ArrangeCallBack';
import Message from './Message';

const SignupModal = ({ closeModal, initialState }) => {
  const start = initialState || 'REGISTER';
  const [startPos] = useState(window.scrollY);
  const [ selectedMenuItem, setSelectedMenuItem ] = useState(start); // 'REGISTER', 'CALL_US', 'CALL_BACK', 'MESSAGE'
  const registerMenuClass = selectedMenuItem === 'REGISTER' ?
    'menu-item active' : 'menu-item';
  const callUsMenuClass = selectedMenuItem === 'CALL_US' ?
    'menu-item active' : 'menu-item';
  const callBackMenuClass = selectedMenuItem === 'CALL_BACK' ?
    'menu-item active' : 'menu-item';
  const messageMenuClass = selectedMenuItem === 'MESSAGE' ?
    'menu-item active' : 'menu-item';
  let content = null;
  if (selectedMenuItem === 'REGISTER') {
    content = <Register />;
  } else if (selectedMenuItem === 'CALL_US') {
    content = <CallUs />;
  } else if (selectedMenuItem === 'CALL_BACK') {
    content = <ArrangeCallBack />;
  } else if (selectedMenuItem === 'MESSAGE') {
    content = <Message />;
  }
  return (
    <Modal close={ closeModal }
      contentClass="signup-modal"
      pos={ startPos }>
      <h2 className="title" data-cy="join-us-title">Join us</h2>
      <div className="menu">
        <div
          onClick={ () => setSelectedMenuItem('REGISTER')}
          className={ registerMenuClass }
          data-cy="create-account-menu-item">
          Create an account
          <div className="line"></div>
        </div>
        <div
          onClick={ () => setSelectedMenuItem('CALL_US')}
          className={ callUsMenuClass }
          data-cy="call-us-menu-item">
          Call us
          <div className="line"></div>
        </div>
        <div
          onClick={ () => setSelectedMenuItem('CALL_BACK')}
          className={ callBackMenuClass }
          data-cy="call-back-menu-item">
          Arrange a callback
          <div className="line"></div>
        </div>
        <div
          onClick={ () => setSelectedMenuItem('MESSAGE')}
          className={ messageMenuClass }
          data-cy="message-menu-item">
          Message
          <div className="line"></div>
        </div>
      </div>
      <div className="signup-section-content">
        { content }
      </div>
    </Modal>
  );
};

SignupModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  initialState: PropTypes.string
};

export default SignupModal;
